export default {
      id: "icon-heart-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "img/icons.svg#icon-heart",
      toString: function () {
        return this.url;
      }
    }